import Media from "components/ui/media"
import Picture from "components/ui/picture"
import { getImgSrcSet } from "helpers/image"

const BASE_IMAGE = `${sl.config.jewlr_imgsmbly_url}cms/m_account_signup_979cb2e7ca/m_account_signup_979cb2e7ca.jpg`
const BASE_HEIGHT = 1440
const BASE_WIDTH = 566

const DESKTOP_IMAGE = `${sl.config.jewlr_imgsmbly_url}cms/d_account_signup_7dc6e7b6dc/d_account_signup_7dc6e7b6dc.jpg`
const DESKTOP_HEIGHT = 1160
const DESKTOP_WIDTH = 964

const Banner = () => (
  <Media greaterThanOrEqual="tablet">
    <Picture
      alt=""
      className="w-(--base-width) desktop:w-(--desktop-width)"
      fallback={DESKTOP_IMAGE}
      srcSet={[
        {
          height: BASE_HEIGHT,
          media: "(max-width: 1023px)",
          srcSet: getImgSrcSet(BASE_IMAGE, BASE_WIDTH),
          width: BASE_WIDTH,
        },
        {
          height: DESKTOP_HEIGHT,
          media: "(min-width: 1024px)",
          srcSet: getImgSrcSet(DESKTOP_IMAGE, DESKTOP_WIDTH),
          width: DESKTOP_WIDTH,
        },
      ]}
      style={{
        "--base-width": "283px",
        "--desktop-width": "482px",
      }}
    />
  </Media>
)

export default Banner
